import { supabase } from './supabase';
import { logger } from './logger';

export interface AdminSubscription {
  id: string;
  employerId: string;
  companyName: string;
  status: string;
  paymentMethod: string | null;
  amountHt: number | null;
  currentPeriodStart: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  createdAt: string;
}

export async function fetchSubscriptions(): Promise<AdminSubscription[]> {
  const { data, error } = await supabase
    .from('subscriptions')
    .select(`
      id,
      employer_id,
      status,
      payment_method,
      amount_ht,
      current_period_start,
      current_period_end,
      cancel_at_period_end,
      created_at,
      employer_profiles!subscriptions_employer_id_fkey ( company_name )
    `)
    .order('created_at', { ascending: false });

  if (error) {
    logger.error('fetch_subscriptions', 'subscriptionService', { error: error.message });
    throw error;
  }
  logger.technical('fetch_subscriptions_ok', 'subscriptionService', { count: (data || []).length });

  return (data || []).map((s: any) => ({
    id: s.id,
    employerId: s.employer_id,
    companyName: s.employer_profiles?.company_name || '',
    status: s.status || 'unknown',
    paymentMethod: s.payment_method,
    amountHt: s.amount_ht,
    currentPeriodStart: s.current_period_start ? new Date(s.current_period_start).toLocaleDateString('fr-FR') : null,
    currentPeriodEnd: s.current_period_end ? new Date(s.current_period_end).toLocaleDateString('fr-FR') : null,
    cancelAtPeriodEnd: s.cancel_at_period_end || false,
    createdAt: new Date(s.created_at).toLocaleDateString('fr-FR'),
  }));
}

export async function activateSubscription(employerId: string): Promise<void> {
  logger.functional('activate_subscription', 'subscriptionService', { employerId });
  const { error } = await supabase
    .from('employer_profiles')
    .update({ subscription_active: true })
    .eq('id', employerId);

  if (error) {
    logger.error('activate_subscription', 'subscriptionService', { employerId, error: error.message });
    throw error;
  }
  logger.technical('activate_subscription_ok', 'subscriptionService', { employerId });
}

export async function deactivateSubscription(employerId: string): Promise<void> {
  logger.functional('deactivate_subscription', 'subscriptionService', { employerId });
  const { error } = await supabase
    .from('employer_profiles')
    .update({ subscription_active: false })
    .eq('id', employerId);

  if (error) {
    logger.error('deactivate_subscription', 'subscriptionService', { employerId, error: error.message });
    throw error;
  }
  logger.technical('deactivate_subscription_ok', 'subscriptionService', { employerId });
}
